export default __webpack_public_path__ + "b600cc4ecc840e65b09cd1d37ba5a221.png";